import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import styles from './styles.css';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const FundingInstitutionScreenFooter = ({ manualProviderName }) => {
  const { next, back } = useContext(FlowContext);

  return (
    <>
      <div className="button-container">
        {manualProviderName && (
          <MFBeaconButton
            id="institutionCustodianContinue"
            data-name={generateGeneralTestID(
              'CustodianInstitution',
              'ContinueButton'
            )}
            className="continue-btn"
            variant="primary"
            size="normal"
            onClick={next({
              custodianName: manualProviderName
            })}
            label="Continue"
          />
        )}

        <MFBeaconButton
          id="institutionCustodianBack"
          data-name={generateGeneralTestID(
            'CustodianInstitution',
            'BackButton'
          )}
          variant="secondary"
          className="beacon-button-margin-override"
          size="normal"
          onClick={back()}
          label="Back"
        />
      </div>

      <style jsx>{styles}</style>
    </>
  );
};

export default FundingInstitutionScreenFooter;
